export const ErrorMessage = ({ message, title }) => (
  <div className="d-flex justify-content-center flex-column align-items-center py-3 px-7x  text-gray-30 text-center">
    <div className="mt-6x text-up-05">
      <span className="fa-solid fa-circle-exclamation" />
    </div>

    <div className="mt-4 mb-0 text-up-02 text-weight-extra-bold text-gray-30 h2">
      {title}
    </div>
    <div className="">{message}</div>
  </div>
);
